/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menufulltitle2Inputs */

const en_menufulltitle2 = /** @type {(inputs: Menufulltitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const de_menufulltitle2 = /** @type {(inputs: Menufulltitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Menufulltitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menufulltitle2 = /** @type {((inputs?: Menufulltitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menufulltitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menufulltitle2(inputs)
	return de_menufulltitle2(inputs)
});
export { menufulltitle2 as "menuFullTitle" }